<!-- <app-header-one [sticky]="true"></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="terms-popup">
    <div class="popup-container">
        <div class="popup-card">
            <!-- <h2 class="title" >{{tncData.title}}</h2> -->
            <!-- <div [innerHTML]="tncData.description"></div> -->
          </div>
          
        <div class="popup-card">
            <h2 class="title" style="cursor: pointer;">Cancellation Policy</h2>
            <!-- <h3 style="text-align: center;">[Employment and Matrimonial Services]</h3>
     -->
    <!-- <p><strong>Effective Date:</strong> 15-Dec-2024 <span style="float: right;"><strong>Last Updated:</strong> 05-Feb-2025</span></p> -->
     <h2>1. Subscription Cancellation </h2>
    <ul>
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	You can cancel your subscription at any time. Navigate to  <strong>Settings, select Subscriptions</strong>, select, and choose “Cancel Subscription.”</li><br><br>
               &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	Cancellation must be done at least  <strong>24 hours before the end of the current billing cycle</strong> to avoid auto-renewal.</li><br><br>
    </ul>
    
    <h2>2. Effect of Cancellation</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	Upon cancellation, you will lose access to premium features of HRMS services after the subscription ends.</li><br><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•	No refunds are issued for unused portions of your subscription period unless required by applicable law.</li><br><br>
</ul>
    <h2>3. NeoHRMZ Application Cancellation</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>•    Once a NeoHRMZ service is accessed, it cannot be cancelled or withdrawn. Contact the recruiter directly for service withdrawal, if necessary.</li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•		If you mistakenly availed our service, please email us at <a href="mailto:support@whiterobe.in">support&#64;neohrmz.com</a> for guidance.</li><br><br>
    </ul>

    <!-- <h2>4. Matrimonial Profile Deletion</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  <li>•	Deleting your profile will automatically cancel your subscription. Ensure you cancel your subscription through your App to stop future payments.</li><br><br>
    </ul> -->
    
    <h2>4. Refund Policy</h2>
    <ul>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li>• Refunds for subscriptions or purchases are managed by NeoHRMZ. If eligible, request a refund through NeoHRMZ Support Team.</li>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<li>•	Refund eligibility is subject to NeoHRMZ’s refund policies.</li><br><br>
    </ul>
    
    <h2>Contact Information for NeoHRMZ Services</h2>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	For questions or concerns about cancellations, contact us at:</p>
    <ul >
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-envelope-o"></i>	Email:</strong> <a href="mailto:supportwhiterobe.in"> contact&#64;neohrmz.com</a></li><br>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <li><strong><i class="fa fa-phone"></i>	Phone:</strong> +91-984 984 8195</li><br>
    </ul>

    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <p>•	Review our  <a (click)="goTo('/terms-and-conditions')">Terms & Conditions</a> and <a (click)="goTo('/privacy')">Privacy Policy</a> for more details.</p>
</div>
</div>

</section>
    <!-- <app-footer-one></app-footer-one> -->
<!-- <app-footer-more-info></app-footer-more-info> -->
 <app-peopleflow-footer></app-peopleflow-footer>
